export class Modal {
  display: string | undefined;
  header: string | undefined;
  content: string | undefined;
  okButton: string | undefined;
  cancelButton: string | undefined;
  submitFunction: () => void;
  closeFunction: () => void;
  data?: any;
}

export const INITIAL_MODAL_STATE: Modal = {
  display: 'none',
  header: '',
  content: '',
  okButton: '',
  cancelButton: '',
  submitFunction: () => {},
  closeFunction: () => {},
  data: undefined
};
export class SuccessModal {
  display!: string;
  content!: string;
  okButton!: string;
  submitFunction!: () => void;
}

export const INITIAL_SUCCESSMODAL_STATE: SuccessModal = {
  display: 'none',
  content: '',
  okButton: '',
  submitFunction: () => {},
};

export interface ResetPassword {
  userType?: string;
  userName?: string;
  verificationCode?: string;
  password?: string;
}

export const INITIAL_RESETPASSWORD_STATE: ResetPassword = {
  userType: '',
  userName: '',
  verificationCode: '',
  password: ''
}
